



























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { IUser, IRekordcloudUserProps, IUiPreferences } from '../../../store/modules/auth'
import * as firebase from 'firebase/app'
import Axios from 'axios'

@Component({
  components: {
    ChangePassword: require('./ChangePassword').default,
    CompanionAppLogin: require('./CompanionAppLogin').default,
    HelpCircle: require('@/components/HelpCircle').default
  }
})
export default class Profile extends Vue {
  emailModel: string = ''
  displayName: string = ''

  errorCode: string = ''
  errorMessage: string = ''

  mailPreferencesPromotions: boolean = false
  mailPreferencesReceipts: boolean = true

  uiPreferencesTutorialsDisabled: boolean = false

  loading: boolean = false

  get user(): IUser {
    return this.$store.state.auth.user
  }

  get email(): string {
    if (!this.emailModel) return ''

    return this.emailModel.trim().toLowerCase()
  }

  get valid(): boolean {
    return !!this.displayName
  }

  get isBetaUser(): boolean {
    return this.$store.getters['auth/isBetaUser']
  }

  async save() {
    if (!this.valid) return

    this.loading = true

    try {
      const user = firebase.auth().currentUser

      if (user) {
        await user.updateProfile({
          displayName: this.displayName
        })

        this.$store.commit('auth/setUser', user)

        this.$buefy.notification.open('Your profile has been updated')

        await this.$router.push({
          name: 'dashboard'
        })
      }
    } catch (error) {
      this.errorMessage = error.message
      this.errorCode = error.code
      console.error(error)
    }

    this.loading = false
  }

  async saveMailPreferences() {
    await Axios.post('/user/mail-preferences', {
      promotions: this.mailPreferencesPromotions,
      receipts: this.mailPreferencesReceipts
    })

    this.$buefy.notification.open('Changes saved')
  }

  async saveUiPreferences() {
    const uiPreferences: IUiPreferences = {
      tutorialsDisabled: this.uiPreferencesTutorialsDisabled
    }

    await Axios.post('/user/ui-preferences', uiPreferences)

    this.$store.commit('auth/setRekordcloudUserProps', {
      uiPreferences
    })

    this.$buefy.notification.open('Changes saved')
  }

  @Watch('$store.state.auth.userProps', { immediate: true })
  watchUserProps(userProps: IRekordcloudUserProps) {
    if (userProps) {
      this.mailPreferencesPromotions = userProps.mailPreferences.promotions
      this.mailPreferencesReceipts = userProps.mailPreferences.receipts
      this.uiPreferencesTutorialsDisabled = userProps.uiPreferences.tutorialsDisabled
    }
  }

  @Watch('user', { immediate: true })
  setUserModel() {
    if (this.user) {
      this.displayName = this.user.displayName
      this.emailModel = this.user.email
    }
  }
}
